import React, { FunctionComponent } from "react";

const NavigationMenuHorizontalIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/menu/navigation-menu-horizontal
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.750 12.023 A2.625 2.625 0 1 0 6.000 12.023 A2.625 2.625 0 1 0 0.750 12.023 Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M18.000 12.023 A2.625 2.625 0 1 0 23.250 12.023 A2.625 2.625 0 1 0 18.000 12.023 Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.375 12.023 A2.625 2.625 0 1 0 14.625 12.023 A2.625 2.625 0 1 0 9.375 12.023 Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default NavigationMenuHorizontalIcon;
